import { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import BuildDeployUsecase from './buildAndDeploy';
import { useLocation, useNavigate } from 'react-router-dom';

const UseCaseComponent = ({ }: any) => {
  const [selectedTab, setSelectedTab] = useState<any>();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    if ((pathname.split('/')).includes('pending-approval')) {
      setSelectedTab(1);
    } else {
      setSelectedTab(0);
    }
  }, [pathname])

  const handleTabChange = (e: any, value: any) => {
    setSelectedTab(value);
    if (value === 0) {
      navigate(`${'/use-cases'}`)
    } else {
      navigate(`${'/use-cases/pending-approval/all'}`)
    }
  };

  return (
    <>
      {selectedTab === 0 && (
        <BuildDeployUsecase onTabChange={handleTabChange} selectedTab={selectedTab} filterStatus='list' />
      )}
      {selectedTab === 1 && (
        <BuildDeployUsecase
          onTabChange={handleTabChange}
          selectedTab={selectedTab}
          filterStatus='waiting_for_approval'
        />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(UseCaseComponent);
